import React, { useRef } from 'react';
import { EditorToolbarCustomFormatActionProps } from '@dev/template-editor';
import { ShowDialogParams } from '@/store/dialog/types';
import { EditorType } from '@/services/dictionaries/EditorType';
import { AiTextModalBody } from './components/AiTextModalBody';
import { AiTextModalHeader } from './components/AiTextModalHeader';
import { AiTextModalFooter } from './components/AiTextModalFooter';

export const useAiTextModalParams = (editorType?: EditorType): {
    getAiTextModalProps: (props: EditorToolbarCustomFormatActionProps) => ShowDialogParams;
} => {
    const inputWrapperRef = useRef<HTMLDivElement>();
    const getAiTextModalProps = (props: EditorToolbarCustomFormatActionProps): ShowDialogParams => ({
        disableHeader: true,
        header: <AiTextModalHeader editorType={editorType} />,
        body: <AiTextModalBody {...props} editorType={editorType} inputWrapperRef={inputWrapperRef} />,
        disabledContentPadding: true,
        id: 'ai-text-tool-modal',
        customButtons: <AiTextModalFooter inputWrapperRef={inputWrapperRef} />,
        width: '950px',
    });
    return { getAiTextModalProps };
};
